// A tiny inline spinner used throughout the app to show "something is happening".
// Uses currentColor so it inherits text color from the surrounding button/text.
export function Spinner({ size = 14, className = "" }) {
  return (
    <svg
      className={`animate-spin ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Loading"
      role="status"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25" />
      <path fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
  );
}

// Full-card / overlay spinner with optional label.
export function SpinnerBlock({ label = "Loading…", size = 22 }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-8 text-stone-500" data-testid="spinner-block">
      <Spinner size={size} />
      <div className="text-xs">{label}</div>
    </div>
  );
}
